import { cn } from "@/lib/utils";
export function Badge({ className, ...p }: React.HTMLAttributes<HTMLSpanElement>) { return <span className={cn("inline-flex items-center gap-1 rounded-md border bg-secondary px-2.5 py-1 text-xs font-semibold text-secondary-foreground", className)} {...p} />; }
